<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <loading-spinner v-if="isLoading"></loading-spinner>
                <paginated-table v-else :data="consentDocuments" :columns="columns"
                    :title="$t('title.consent_document_list')" @updatePagination="updatePagination">
                    <template v-slot:top-buttons>
                        <custom-button @click="add" :label="$t('button.add')" color="primary" icon="add" size="lg"
                            gradient rounded></custom-button>
                    </template>
                </paginated-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PaginatedTable from "@/components/Tables/PaginatedTable.vue";
import CustomButton from '@/components/common/buttons/CustomButton.vue';
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';

import { consentDocumentApi } from "@/api/api";
import { getConsentDocumentManagementColumns } from "@/fields/journal/columns";

export default {
    components: {
        PaginatedTable,
        CustomButton,
        LoadingSpinner,
    },
    data() {
        return {
            consentDocuments: {
                page_info: {
                    page: 1,
                    size: 5,
                    total_elements: 5,
                    total_pages: 1,
                },
                elements: [],
            },
            isLoading: false,
            columns: getConsentDocumentManagementColumns({
                "detail": this.showDetail,
            })
        };
    },
    methods: {
        /* ****************************************************************************************
         * 이벤트 핸들러
         * ****************************************************************************************/
        showDetail(item) {
            this.$router.push(`/journals/consent-documents/${item.idx}`);
        },
        add() {
            this.$router.push(`/journals/consent-documents/create`);
        },
        updatePagination(pagination) {
            this.consentDocuments.page_info.size = pagination.size;
            this.consentDocuments.page_info.page = pagination.page;
            this.fetchConsentDocuments();
        },

        /* ****************************************************************************************
         * API 호출
         * ****************************************************************************************/
        async fetchConsentDocuments() {
            this.isLoading = true;
            const params = {
                page: this.consentDocuments.page_info.page,
                size: this.consentDocuments.page_info.size,
            };
            try {
                const response = await consentDocumentApi.showAll(params);
                if (response.status === 200) {
                    this.consentDocuments = response.data.response;
                }
            } catch (error) {
                this.notifyVue({ message: this.$t('alert.failed_request'), style: "danger" });
                this.$router.push({ name: "dashboard" });
            } finally {
                this.isLoading = false;
            }
        },

        /* ****************************************************************************************
         * 알럿
         * ****************************************************************************************/
        notifyVue({
            vertical = "top",
            horizontal = "right",
            message = "",
            style = "primary",
            icon = "priority_high",
        } = {}) {
            this.$notify({
                timeout: 8000,
                message: message,
                icon: icon,
                type: style,
                horizontalAlign: horizontal,
                verticalAlign: vertical,
            });
        }
    },
    mounted() {
        this.fetchConsentDocuments();
    }
}
</script>